export const categoryPage = "categoryPage";
export const subCategoryPage = "subCategoryPage";
export const searchPage = "searchPage";
export const productPage = "productPage";
export const productDetailPageType = "product-detail";
export const brandPage = "brandPage";

// Backend CMS Page Types
export const pricingPage = "pricing";
export const homepagePage = "homepage";
export const featurePage = "feature";
export const cmsPage = "cms";
export const productListingPage = "product_listing_page";
export const searchProductListingPage = "search_page";
export const brandProductListingPage = "brand_page";
export const collectionListingPage = "collection_page";
export const cartPage = "cart_page";
export const checkoutPage = "checkout_page";
export const orderConfirmationPage = "order_confirmation_page";
export const productDetailPage = "product_detail_page";
export const cmsCatalogPage = "catalog_page";
export const catalogEntriesPage = "category_page";
export const redeemGiftCardPage = "redeem_gift_card_page";

// Backend CMS Page type denoting that this is a store page.
export const shopsPage = "shops";
